// extracted by mini-css-extract-plugin
module.exports = {"container":"fEIKeV48NALjJjwOmaKtk","visible":"N-7-TUAGmIMKegDhEukp9","cancelBtn":"_3nxjGobceyzAogDPI8SHta","icon":"_31MIkoCDXhYPYKplbJQVQ0","saveBtn":"_3-ZN1NLlxt2S7gukXp2UC-"};